import React, { useState, useEffect } from "react";
import { Form, Row, Col, Button, Modal } from "react-bootstrap";
import WorkReportLayout from "../../components/EmpWorkReportLayout.jsx";
import { SiGoogledocs } from "react-icons/si";
import "jspdf-autotable"; // For PDF table
import { TbLoader3 } from "react-icons/tb"; // Importing the loader icon
import "./all-work-reports.css";
import { IoEye } from "react-icons/io5";
import * as XLSX from "xlsx"; // Importing xlsx library for Excel export
import { jsPDF } from "jspdf"; // Importing jsPDF for PDF export
export default function EmpsWorkReports() {
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [selectedUser, setSelectedUser] = useState("");
  const [showErrors, setShowErrors] = useState(false);
  const [showTable, setShowTable] = useState(false);
  const [isGenerating, setIsGenerating] = useState(false); // Define isGenerating state
  const [users, setUsers] = useState([]); // State to store fetched users
  const [reports, setReports] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");

  const [showModal, setShowModal] = useState(false); // Modal visibility state
  const [selectedReport, setSelectedReport] = useState(null); // Selected report details
  const [entriesPerPage, setEntriesPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);

  const filteredReports = reports.filter((report) => {
    return (
      report.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
      report.username.toLowerCase().includes(searchQuery.toLowerCase()) ||
      report.reportingDate.includes(searchQuery)
    );
  });

  const totalPages = Math.ceil(filteredReports.length / entriesPerPage);

  const handlePageChange = (pageNumber) => {
    if (pageNumber >= 1 && pageNumber <= totalPages) {
      setCurrentPage(pageNumber);
    }
  };

  const pageRange = () => [...Array(totalPages).keys()].map((i) => i + 1);

  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const response = await fetch(
          "https://backend.ems.hiradentallab.com/api/user/getAllUsers"
        );
        if (!response.ok) {
          throw new Error("Failed to fetch users");
        }
        const data = await response.json();
        setUsers(data);
      } catch (error) {
        console.error("Error fetching users:", error);
        alert("Failed to fetch user data. Please try again.");
      }
    };

    fetchUsers();
  }, []);

  const validateForm = () => {
    const errors = {};
    if (!selectedUser) errors.selectedUser = "UserName is required";
    if (!startDate) errors.startDate = "Start date is required";
    if (!endDate) errors.endDate = "End date is required";
    return errors;
  };

  const handleGenerateReport = async () => {
    const errors = validateForm();
    if (Object.keys(errors).length > 0) {
      setShowErrors(true);
      return;
    }

    setShowErrors(false);
    setIsGenerating(true); // Start generating report

    try {
      const response = await fetch(
        "https://backend.ems.hiradentallab.com/api/reports/username-dates",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            username: selectedUser,
            startDate,
            endDate,
          }),
        }
      );

      if (!response.ok) {
        throw new Error("Failed to fetch reports");
      }

      const data = await response.json();
      if (data.message) {
        alert(data.message); // Show message if no reports found
      } else {
        setReports(data.reports); // Assuming the reports are returned in data.reports
        setShowTable(true); // Show the table after fetching data
      }
    } catch (error) {
      console.error("Error fetching reports:", error);
      alert("Failed to fetch reports. Please try again.");
    } finally {
      setIsGenerating(false); // Stop generating report
    }
  };

  const isFormValid = () => {
    return selectedUser && startDate && endDate; // Check if the form is valid
  };
  const handleOpenModal = (report) => {
    setSelectedReport(report);
    setShowModal(true); // Open the modal
  };

  const handleCloseModal = () => {
    setShowModal(false); // Close the modal
    setSelectedReport(null); // Clear the selected report
  };
  // Function to export data to Excel
  const exportToExcel = () => {
    const ws = XLSX.utils.json_to_sheet(reports); // Convert reports to Excel sheet
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Reports");
    XLSX.writeFile(wb, "today_reports.xlsx"); // Save file as "today_reports.xlsx"
  };

  // Function to export data to PDF
  const exportToPDF = () => {
    const doc = new jsPDF();

    // Add table title
    doc.setFontSize(18);
    doc.text("Today Work Reports", 20, 20);

    // Add table headers
    doc.setFontSize(12);
    doc.text("SR", 20, 30);
    doc.text("UserName", 40, 30);
    doc.text("Name", 90, 30);
    doc.text("Reporting Date", 140, 30);
    doc.text("Reporting Time", 200, 30);
    doc.text("Updated at", 260, 30);

    // Add table rows
    reports.forEach((data, index) => {
      const yPosition = 40 + index * 10;
      doc.text(String(index + 1), 20, yPosition);
      doc.text(data.username, 40, yPosition);
      doc.text(data.name, 90, yPosition);
      doc.text(
        new Date(data.reportingDate).toLocaleDateString(),
        140,
        yPosition
      );
      doc.text(data.reportingTime, 200, yPosition);
      doc.text(new Date(data.updatedAt).toLocaleString(), 260, yPosition);
    });

    doc.save("today_reports.pdf"); // Save as "today_reports.pdf"
  };

  return (
    <div className="container-fluid">
    <WorkReportLayout>
      <h1 className="all-report-title">
        <SiGoogledocs /> All Report
      </h1>
      <hr />
      <Form className="all-report-form">
        <Row>
          <Form.Group as={Col} xs={12} md={4} controlId="formGridUserName">
            <Form.Label>
              UserName <span className="required">*</span>:
            </Form.Label>
            <Form.Select
              name="username"
              required
              value={selectedUser}
              onChange={(e) => setSelectedUser(e.target.value)}
              className="form-control fancy-select"
              isInvalid={showErrors && !selectedUser}
            >
              <option value="">Select a Username</option>
              {users.map((user) => (
                <option key={user._id} value={user.username}>
                  {user.username}
                </option>
              ))}
            </Form.Select>
            <Form.Control.Feedback type="invalid">
              {showErrors && !selectedUser ? "UserName is required" : ""}
            </Form.Control.Feedback>
          </Form.Group>

          <Col xs={12} md={4}>
            <Form.Group>
              <Form.Label htmlFor="start_date">
                Start date <span className="required">*</span> :
              </Form.Label>
              <Form.Control
                type="date"
                id="start_date"
                name="start_date"
                required
                value={startDate}
                onChange={(e) => setStartDate(e.target.value)}
                isInvalid={showErrors && !startDate}
              />
              <Form.Control.Feedback type="invalid">
                {showErrors && !startDate ? "Start date is required" : ""}
              </Form.Control.Feedback>
            </Form.Group>
          </Col>

          <Col xs={12} md={4}>
            <Form.Group>
              <Form.Label htmlFor="end_date">
                End date <span className="required">*</span> :
              </Form.Label>
              <Form.Control
                type="date"
                id="end_date"
                name="end_date"
                required
                value={endDate}
                onChange={(e) => setEndDate(e.target.value)}
                isInvalid={showErrors && !endDate}
              />
              <Form.Control.Feedback type="invalid">
                {showErrors && !endDate ? "End date is required" : ""}
              </Form.Control.Feedback>
            </Form.Group>
          </Col>
        </Row>

        <Button
          className="generate-report-button"
          type="button"
          onClick={handleGenerateReport}
          disabled={showErrors || !isFormValid() || showTable} // Disable if there are errors, form is invalid, or table is shown
        >
          {isGenerating && !showTable ? (
            <TbLoader3 className="icon-rotate" />
          ) : (
            "Generate Report"
          )}
        </Button>
      </Form>
      {showTable && (
        <div className="emps-leave-report-table-container">
          <div className="table-actions">
            <Row className="w-100">
              <Col
                xs={12}
                md={6}
                className="d-flex align-items-center mb-3 justify-content-start"
              >
                {/* Excel and PDF export buttons */}
                <Button
                  variant="secondary"
                  className="export-button"
                  onClick={exportToExcel}
                >
                  Excel
                </Button>
                <Button
                  variant="secondary"
                  className="export-button"
                  style={{ marginLeft: "10px" }}
                  onClick={exportToPDF}
                >
                  PDF
                </Button>
              </Col>
            </Row>
          </div>
          <div className="table-responsive">
            <table className="table table-striped">
              <thead className="all-report-table-header">
                <tr className="table-header">
                  <th>SR</th>
                  <th>UserName</th>
                  <th>Name</th>
                  <th>Reporting Date</th>
                  <th>Reporting Time</th>
                  <th>Updated at</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {reports.map((data, index) => (
                  <tr key={data._id}>
                    <td>{index + 1}</td>{" "}
                    {/* SR column starts counting from 1 */}
                    <td>{data.username}</td>
                    <td>{data.name}</td>
                    <td>
                      {new Date(data.reportingDate).toLocaleDateString()}
                    </td>{" "}
                    {/* Formatting the date */}
                    <td>{data.reportingTime}</td> {/* Formatting the time */}
                    <td>{new Date(data.updatedAt).toLocaleString()}</td>{" "}
                    {/* Formatting the updated date */}
                    <td>
                      <Button
                        variant="primary"
                        size="sm"
                        onClick={() => handleOpenModal(data)}
                      >
                        <IoEye />
                      </Button>
                    </td>
                  </tr>
                ))}
              </tbody>
              <tfoot className="table-footer">
                <tr className="all-report-table-footer">
                  <td>Total</td>
                  <td>{reports.length}</td> {/* Total number of entries */}
                  <td colSpan="5"></td>{" "}
                  {/* Empty columns to align the footer */}
                </tr>
              </tfoot>
            </table>

            <div className="pagination-row">
              <div className="entries-info">
                Showing {(currentPage - 1) * entriesPerPage + 1} to{" "}
                {Math.min(currentPage * entriesPerPage, filteredReports.length)}{" "}
                of {filteredReports.length} entries
              </div>
              <nav>
                <ul className="pagination no-gap">
                  <li
                    className={`page-item ${
                      currentPage === 1 ? "disabled" : ""
                    }`}
                  >
                    <a
                      href="/#"
                      className="page-link"
                      onClick={(e) => {
                        e.preventDefault();
                        handlePageChange(currentPage - 1);
                      }}
                    >
                      Previous
                    </a>
                  </li>
                  {pageRange().map((pageNumber) => (
                    <li
                      key={pageNumber}
                      className={`page-item ${
                        currentPage === pageNumber ? "active" : ""
                      }`}
                    >
                      <a
                        href="/#"
                        className="page-link"
                        onClick={(e) => {
                          e.preventDefault();
                          handlePageChange(pageNumber);
                        }}
                      >
                        {pageNumber}
                      </a>
                    </li>
                  ))}
                  <li
                    className={`page-item ${
                      currentPage === totalPages ? "disabled" : ""
                    }`}
                  >
                    <a
                      href="/#"
                      className="page-link"
                      onClick={(e) => {
                        e.preventDefault();
                        handlePageChange(currentPage + 1);
                      }}
                    >
                      Next
                    </a>
                  </li>
                </ul>
              </nav>
            </div>
            {/* Modal for report details */}
            <Modal show={showModal} onHide={handleCloseModal} centered>
              <Modal.Header
                closeButton
                style={{ background: "#004aad", color: "#ffffff" }}
              >
                <Modal.Title>Report Details</Modal.Title>
              </Modal.Header>
              <Modal.Body style={{ padding: "20px" }}>
                {selectedReport && (
                  <div>
                    <h6 style={{ fontWeight: "bold" }}>
                      Start Date:{" "}
                      <span style={{ fontStyle: "italic", color: "#007bff" }}>
                        {new Date(
                          selectedReport.reportingDate
                        ).toLocaleDateString()}
                      </span>
                    </h6>
                    <h6 style={{ fontWeight: "bold" }}>
                      Reporting Time:{" "}
                      <span style={{ fontStyle: "italic", color: "#007bff" }}>
                        {selectedReport.reportingTime}
                      </span>
                    </h6>
                    <div
                      style={{
                        border: "1px solid #007bff",
                        padding: "10px",
                        borderRadius: "5px",
                        backgroundColor: "#f8f9fa",
                      }}
                      dangerouslySetInnerHTML={{
                        __html: selectedReport.report,
                      }}
                    />
                  </div>
                )}
              </Modal.Body>
              <Modal.Footer>
                <Button variant="secondary" onClick={handleCloseModal}>
                  Close
                </Button>
              </Modal.Footer>
            </Modal>
          </div>
        </div>
      )}
    </WorkReportLayout>
    </div>
  );
}
